import { render } from "./Dropzone.vue?vue&type=template&id=5e570f99"
import script from "./Dropzone.vue?vue&type=script&lang=js"
export * from "./Dropzone.vue?vue&type=script&lang=js"

import "./Dropzone.vue?vue&type=style&index=0&id=5e570f99&lang=scss"
script.render = render

export default script